document.addEventListener("DOMContentLoaded", function () {
  // Scope to this snippet instance (script -> previousElementSibling = the <ul>)
  //   var root =
  //     document.currentScript && document.currentScript.previousElementSibling;
  //   if (!root) return;

  document.querySelectorAll(".footer-acc-toggle").forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute("aria-controls"));
    if (!panel) return;

    btn.addEventListener("click", function () {
      var expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!expanded));
      panel.hidden = expanded;

      // Optional: rotate caret
      var caret = btn.querySelector(".footer-acc-caret");
      if (caret)
        caret.style.transform = expanded ? "rotate(-90deg)" : "rotate(0deg)";
    });
  });
});
